<ng-container *ngIf="state$ | async as state">
  <!-- Idle: show login form -->
  <div class="body" *ngIf="state.connectionState === 'idle'">
    <app-widget-form
      [description]="description"
      [formSections]="formSections"
      [formValues]="formValues"
      (cancelled)="onCancelled()"
      (submitted)="onFormSubmitted($event)"
      (closeStateChanged)="onCloseStateChanged($event)"
    ></app-widget-form>
  </div>

  <!-- Progress: logging in or connecting -->
  <div
    class="card__loader"
    *ngIf="state.connectionState === 'logging-in' || state.connectionState === 'connecting'"
  >
    <img src="/assets/loaders/bloom_spinner.gif" alt="loader" />
    <p class="card__loader__text">
      {{ state.isLoggedIn ? 'Connecting' : 'Logging In' }}
    </p>
  </div>

  <!-- Failure -->
  <div class="card__failure" *ngIf="state.connectionState === 'failure'">
    <p class="card__failure__text">{{ state.errorMessage }}</p>
    <object
      class="card__failure__cross"
      type="image/svg+xml"
      data="/assets/icons/animated/cancelled.svg"
    ></object>
    <div class="card__failure__buttons">
      <button class="btn btn-danger-outline btn-lg" (click)="onCancelled()">Close</button>
      <button *ngIf="!state.testConnection" class="btn btn-primary btn-lg" (click)="retry(state)">
        Retry
      </button>
      <button
        *ngIf="state.testConnection"
        class="card__success__text__send"
        (click)="retry(state)"
        [class.processing]="!state.buttonEnabled"
        style="margin-left: 16px"
      >
        <img
          class="card__success__text__send__image"
          [src]="
            !state.buttonEnabled
              ? '/assets/icons/action-dialog/iconDisabled.svg'
              : '/assets/icons/action-dialog/sidekickBtn.svg'
          "
          alt=""
        />
        <span>Retry</span>
      </button>
    </div>
  </div>

  <!-- Success (brief transition) -->
  <div class="card__success" *ngIf="state.connectionState === 'success'">
    <p class="card__success__text">SideKick Device has been connected successfully!</p>
    <object
      class="card__success__tick"
      type="image/svg+xml"
      data="/assets/icons/animated/check_mark.svg"
    ></object>
  </div>

  <!-- Connected: device management panel -->
  <div
    class="card__success connectedToPms"
    *ngIf="state.connectionState === 'connected' && !state.showFeedback"
  >
    <p class="card__success__text" *ngIf="state.connectedDeviceName">
      {{ state.connectedDeviceName }}
    </p>
    <p class="card__success__text">Connect to a different SideKick Device?</p>
    <div class="card__success__buttons disconnect">
      <button class="btn btn-danger-outline btn-lg" (click)="disconnect()">Disconnect</button>
      <button
        class="card__success__text__send"
        (click)="pushScreen(SideKickInterfaceTypeUiEnum.SIDEKICK_SCREEN_TEST)"
        [class.processing]="!state.buttonEnabled"
      >
        <img
          class="card__success__text__send__image"
          [src]="
            !state.buttonEnabled
              ? '/assets/icons/action-dialog/iconDisabled.svg'
              : '/assets/icons/action-dialog/sidekickBtn.svg'
          "
          alt=""
        />
        <span>Test</span>
      </button>
    </div>

    <div class="seperator__condition">
      <div class="seperator__dashedTop"></div>
      <div>OR</div>
      <div class="seperator__dashedTop"></div>
    </div>

    <button
      class="card__success__text__send"
      (click)="pushScreen(SideKickInterfaceTypeUiEnum.SELF_CHECK_IN_DEFAULT)"
      [class.processing]="!state.buttonEnabled"
    >
      <img
        class="card__success__text__send__image"
        [src]="
          !state.buttonEnabled
            ? '/assets/icons/action-dialog/iconDisabled.svg'
            : '/assets/icons/action-dialog/sidekickBtn.svg'
        "
        alt=""
      />
      <span>Push Self Check-In</span>
    </button>

    <button
      class="card__success__text__send"
      (click)="pushScreen(SideKickInterfaceTypeUiEnum.BOOKING_DEFAULT)"
      [class.processing]="!state.buttonEnabled"
    >
      <img
        class="card__success__text__send__image"
        [src]="
          !state.buttonEnabled
            ? '/assets/icons/action-dialog/iconDisabled.svg'
            : '/assets/icons/action-dialog/sidekickBtn.svg'
        "
        alt=""
      />
      <span>Push Pay At Hotel</span>
    </button>

    <ng-container
      *ngIf="
        (propertyData?.feedbackUrl && propertyData?.feedbackUrl !== '') ||
        (propertyData?.feedbackUrl2 && propertyData?.feedbackUrl2 !== '')
      "
    >
      <div class="seperator__condition">
        <div class="seperator__dashedTop"></div>
        <div>OR</div>
        <div class="seperator__dashedTop"></div>
      </div>
      <button class="btn btn-secondary-outline btn-lg" (click)="toggleFeedback()">
        Feedback Options
      </button>
    </ng-container>
  </div>

  <!-- Feedback panel -->
  <div class="card__failure" *ngIf="state.connectionState === 'connected' && state.showFeedback">
    <p class="card__failure__text">Push hotel review screen on the SideKick Device.</p>
    <br />
    <div class="feedback">
      <button
        *ngIf="propertyData?.feedbackUrl && propertyData?.feedbackUrl !== ''"
        class="card__success__text__send"
        (click)="
          pushScreen(SideKickInterfaceTypeUiEnum.FRONT_DESK_ASSISTANT_FEEDBACK_EXTERNAL, 'Google')
        "
        [class.processing]="!state.buttonEnabled"
      >
        <img
          class="card__success__text__send__image"
          [src]="
            !state.buttonEnabled
              ? '/assets/icons/action-dialog/iconDisabled.svg'
              : '/assets/icons/action-dialog/sidekickBtn.svg'
          "
          alt=""
        />
        <span>Push Google review</span>
      </button>
      <button
        *ngIf="propertyData?.feedbackUrl2 && propertyData?.feedbackUrl2 !== ''"
        class="card__success__text__send feedback__tripadvisor"
        (click)="
          pushScreen(
            SideKickInterfaceTypeUiEnum.FRONT_DESK_ASSISTANT_FEEDBACK_EXTERNAL,
            'Tripadvisor'
          )
        "
        [class.processing]="!state.buttonEnabled"
      >
        <img
          class="card__success__text__send__image"
          [src]="
            !state.buttonEnabled
              ? '/assets/icons/action-dialog/iconDisabled.svg'
              : '/assets/icons/action-dialog/sidekickBtn.svg'
          "
          alt=""
        />
        <span>Push TripAdvisor review</span>
      </button>
    </div>
    <br />
    <button class="btn btn-danger-outline btn-lg" (click)="toggleFeedback()">Go Back</button>
  </div>
</ng-container>
